<script>
import sendIconSrc from './icons/send-icon.svg'
import SpeechToText from './SpeechToText.vue';

export default {
    components: {
        SpeechToText
    },
    props: {
        questionLeft: Number,
        sessionQuestionLeft: Number,
        characterLimit: Number,
        isSending: Boolean,
        isOverTime: Boolean,
        config: Object,
        frequencyLabel: String,
        metadata: {
            default() {
                return null
            }
        },
        info: {
            default() {
                return null
            }
        },
    },
    data() {
        return {
            sendIconSrc,
            chatMessage: ''
        }
    },

    computed: {
        isCharacterLimited() {
            return typeof this.characterLimit !== 'number'
                || (
                    this.characterLimit > 0
                    && this.characterLimit - this.chatMessage.length < 0
                )
        },
        isSendable() {
            return !this.isSending
                && this.questionLeft !== 0
                && this.sessionQuestionLeft !== 0
                && !this.isCharacterLimited
                && !this.isOverTime
        }
    },
    methods: {
        handleSubmit() {
            if (!this.isSendable) return;
            window.boChatbot?.sendMessage(this.chatMessage, this.metadata, this.info)
            this.chatMessage = ''
        },
        focus() {
            this.$refs.sendingInput?.focus()
        }
    }
}
</script>

<template>
    <div v-if="!isOverTime">
        <div v-if="questionLeft !== null" class="sending-question-limit" :class="{ 'over': questionLeft === 0 }">
            <template v-if="questionLeft === 0">
                {{ $t('ai_tutor_over_limit', { frequency: frequencyLabel }) }}
            </template>
            <template v-else>
                {{ $t('ai_tutor_question_limit', { limit: questionLeft, frequency: frequencyLabel }) }}
            </template>
        </div>
        <div v-if="sessionQuestionLeft === 0" class="sending-question-limit over">
            {{ $t('ai_tutor_session_over_limit') }}
        </div>
        <div v-if="isCharacterLimited" class="sending-question-limit over">
            {{ $t('ai_tutor_character_over_limit') }}
        </div>
        <form @submit.prevent="handleSubmit" class="sending-form">
            <input ref="sendingInput" required v-model="chatMessage" class="sending-input"
                :placeholder="$t('ai_tutor_chatbox')" />
            <!-- <speech-to-text v-model="chatMessage" /> -->
            <button type="submit" class="sending-button" :disabled="!isSendable" :class="{ 'disabled': !isSendable }">
                <img :src="sendIconSrc" class="sending-icon" />
            </button>
        </form>
    </div>
</template>

<style scoped>
.sending-wrapper {
    border-radius: 9999px;
    background-color: #F3F3F3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.8rem;
}

.sending-question-limit {
    font-size: 0.65rem;
    font-style: italic;
    margin: 0 1.5rem;
    color: #212529;
}

.sending-question-limit.over {
    color: #EA2A37;
}

.sending-form {
    border-radius: 9999px;
    background-color: #F3F3F3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.8rem;
    margin: 0;
}

.sending-input {
    background-color: transparent;
    border: none;
    outline: none;
    font-size: 0.9rem;
    padding: 0.8rem 0 0.8rem 1.2rem;
    flex-grow: 1;
}

.sending-input:read-only {
    cursor: not-allowed;
}

.sending-button {
    border: none;
    outline: none;
    border-radius: 100%;
    width: 2.8rem;
    height: 2.8rem;
    background-color: #3CB7FD;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
}

.sending-button.disabled {
    background-color: #999;
    cursor: not-allowed;
}

.sending-icon {
    width: 1.3rem;
    height: auto;
}
</style>